export default {
  text: {
    en: `
      You may experience shipping delays or partial shipments due to our warehouse move this month.
      We sincerely apologize and will continue to send updates. Please read this letter from our CEO.
    `,
  },
  button: {
    en: 'Read our update',
  },
}
